/**
 * Change the logo color to blue or white by swaping the img src
 * @param logoColor
 */
export const changeCgLogoDesktop = (logoColor) => {

    /**
     * Initialize null logoImgEle
     * @type {HTMLElement}
     */
    let logoImgEle = null;

    /**
     * Get the headerBottom element
     * @type {HTMLElement}
     */
    const headerBottom = document.querySelector('.header-bottom');
    if(headerBottom) {
        /**
         * Get the logoImgEle
         * @type {HTMLImageElement}
         */
        logoImgEle = headerBottom.querySelector('.logo img');
    }

    if(logoImgEle && logoImgEle.dataset && logoImgEle.dataset.whiteLogoSrc && logoImgEle.dataset.blueLogoSrc) {

        switch (logoColor) {
            case 'white':
                logoImgEle.src = logoImgEle.dataset.whiteLogoSrc;
                return;
            case 'blue':
                logoImgEle.src = logoImgEle.dataset.blueLogoSrc;
                return;
            default:
                logoImgEle.src = logoImgEle.dataset.blueLogoSrc;
        }
    }
};


/**
 * Change logo color for mobile
 * @param logoColor
 */
export const changeCgLogoMobile = (logoColor) => {

    /**
     * Initialize null logoImgEle
     * @type {HTMLElement}
     */
    let logoImgEle = null;

    /**
     * Get the headerBottom element
     * @type {HTMLElement}
     */
    const headerMobile = document.querySelector('.header-mobile');
    if(headerMobile) {
        /**
         * Get the logoImgEle
         * @type {HTMLImageElement}
         */
        logoImgEle = headerMobile.querySelector('.logo img');
    }

    if(logoImgEle && logoImgEle.dataset && logoImgEle.dataset.whiteLogoSrc && logoImgEle.dataset.blueLogoSrc) {

        switch (logoColor) {
            case 'white':
                logoImgEle.src = logoImgEle.dataset.whiteLogoSrc;
                return;
            case 'blue':
                logoImgEle.src = logoImgEle.dataset.blueLogoSrc;
                return;
            default:
                logoImgEle.src = logoImgEle.dataset.blueLogoSrc;
        }
    }
};

export const changeCgGlobalLangIcon = (logoColor) => {

    /**
     * Get the headerBottom element
     * @type {HTMLElement}
     */
    const langIconEle = document.querySelector('.language-icon');

    if(langIconEle && langIconEle.dataset && langIconEle.dataset.whiteGlobalIconSrc && langIconEle.dataset.blackGlobalIconSrc) {

        switch (logoColor) {
            case 'white':
                langIconEle.src = langIconEle.dataset.whiteGlobalIconSrc;
                return;
            case 'black':
                langIconEle.src = langIconEle.dataset.blackGlobalIconSrc;
                return;
            default:
                langIconEle.src = langIconEle.dataset.blackGlobalIconSrc;
        }
    }
};
